
export const environment = {

  production: true,
  serverUrl:"https://api.reekoo.net/",
  mediaServerURL:"https://api.reekoo.net/static/upload_files/",
  videoScreenshotServerURL:"https://api.reekoo.net/static/thumbnail/",
  videoServerURL:"https://api.reekoo.net/static/videos/",
  //serverUrl:"http://localhost:2500/",
  //mediaServerURL:"http://localhost:2500/upload_files/",
  app_auth_key_query:"?os=admin&api_key=b93e0a61edd5e0f7fe7515911e17820657c37d10439e78e8bc0c048e&api_code=b93e0a61edd5e0f7fe7515911e17820657c37d10439e78e8bc0c048e",
  defaultauth: 'adminApi',
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '13.39.13.146',
    measurementId: ''
  }
};

